import { InitializationCtrl } from '../controllers/InitializationCtrl';
import { Module } from '../Module';

Module.instance().directive('tbInitialization',
  () => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'initialization.html',
      scope: {},
      controller: InitializationCtrl
    };
  }
);
